import { Component, OnInit } from '@angular/core';

import { AppService } from '../../../services/app.service';
import { ITableColumn } from '../../../shared/table/table.component';
import { NotificationTemplateService } from '../../../services/notification-template.service';
import { INotificationTemplateListItem } from '../../../models/NotificationTemplate';

@Component({
    selector: 'app-notification-template-list',
    templateUrl: './notification-template-list.component.html'
})
export class NotificationTemplateListComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: NotificationTemplateService
    ) { }

    items: INotificationTemplateListItem[] = [];

    readonly canEdit = this.app.currentUser?.rights.includes('NOTIFICATION_TEMPLATE.EDIT');

    readonly columns: ITableColumn[] = [
        { property: 'Name', label: 'notificationTemplate_lblName', sorts: true },
        { property: 'Type', label: 'notification_lblType', sorts: true },
        { property: 'SubjectLV', label: 'notification_lblSubjectLV', sorts: true },
        { property: 'SubjectEN', label: 'notification_lblSubjectEN', sorts: true },
        { width: '1px' }
    ];

    ngOnInit() {
        this.fetch();
    }

    delete(item: INotificationTemplateListItem) {
        this.app.confirm(this.app.translate('confirmItemDelete'), result => {
            if (!result) return;

            this.app.addLoading(this.service.delete(item.Id)).subscribe(() => {
                this.fetch();
            });
        });
    }

    private fetch() {
        this.app.addLoading(this.service.get()).subscribe(data => {
            this.items = data;
        });
    }
}
